<template lang='pug'>
  include /mixins
  div.relative-wrapper
    +b.i-filter
      div.i-filter-header(@click.prevent="toggleMobileMenu")
        +b.SPAN {{ _("Фильтр") }}

      +b.i-filter-wrapper
        filter-sorting-widget(
          :value="prepared ? prepared.order : 'default'",
          :filters="prepared"
          :choices="orderChoices.items"
          @input="handleInputFilter"
        )

        filter-ui(
          ref="filterUi"
          :disabled="loading"
          :value="prepared"
          :filters="preparedFilters"
          :pagination='pagination'
          :additional-resource="additionalResource"
          :label="label"
          @input="handleInputFilter"
        )

      div.i-filter__btn-block
        +b-context("i-filter")
          +e.clean-filter
            +b.BUTTON.link-button(@click.prevent='handleInputFilter({}, "clear")') {{ _("Очистити фільтр") }}
</template>

<script>

import ControllerMixin from './mixins/ControllerMixin'
import FilterSortingWidget from '@components/Filters/FilterSorting'
import { mapActions } from 'vuex'

export default {
  components: {
    FilterSortingWidget,
  },
  mixins: [ControllerMixin],
  methods: {
    ...mapActions('ui', ['toggleMobileMenu']),
  },
  computed: {
    orderChoices() {
      return this.filters.find(el => 'order' === el.name)
    },
    preparedFilters() {
      return this.filters.filter(el => 'order' !== el.name)
    },
  }
}

</script>
